import styled from "@emotion/styled";

import { Badge } from "components/basic";

export const StyledBadge = styled(Badge)`
  margin-right: 6px;
`;
